import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class HotelbookingsService {
  constructor(private restService: RestService) {}

  all(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('hotelbooking/all', val_params);
  }

  list(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('hotelbooking/list', val_params);
  }

  listCheckins(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('hotelbooking/list/checkins', val_params);
  }

  planning(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('hotelbooking/planning', val_params);
  }

  transfers(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('hotelbooking/transfers', val_params);
  }

  get(val_id: number) {
    return this.restService.get('hotelbooking/edit', val_id);
  }

  detail(val_id: number) {
    return this.restService.get('hotelbooking/detail', val_id);
  }

  save(data: any) {
    return this.restService.save('hotelbooking/save', data);
  }

  update(val_id: number, data: any) {
    return this.restService.update('hotelbooking/update', val_id, data);
  }

  updateSave(data: any) {
    return this.restService.save('hotelbooking/update/save', data);
  }

  delete(val_id: number) {
    return this.restService.delete('hotelbooking/delete', val_id);
  }

  availableBedroom(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('hotelbooking/bedroom/available', val_params);
  }

  updateRatesBedroomByTypeRate(data: any) {
    return this.restService.save('hotelbooking/update_rates/by_type_rate', data);
  }


  checkin(val_id: number, data: any) {
    return this.restService.update('hotelbooking/checkin', val_id, data);
  }
  
}


